<div class="choose-image">
  <ng-container *ngFor="let name of fieldInfo?.translations">
    <h5 for="configuration-name" class="label-name" *ngIf="name.lang === panelLanguage">{{ name.label }}</h5>
  </ng-container>
  <div class="image-wrapper" (click)="open()">
    <img class="button-image" [src]="choosenImageSource" />
  </div>
</div>
